<template>
<div id="analyshop">
  <b-field grouped group-multiline>
    <b-select v-model.number="selectedShop" @input="onShopSelect" expanded>
      <option value="1">角色</option>
      <option value="2">道具</option>
      <option value="3">numuser</option>
    </b-select>
    <date-quick @change="onDateQuick" expanded/>
    <b-datepicker
      placeholder="开始日期"
      v-model="fromDate"
      :min-date="minDate"
      :max-date="maxDate"
      :date-formatter="formatDate"
      icon="calendar-today"
      expanded
      @input="onDateInput">
    </b-datepicker>
    <b-datepicker
      placeholder="截止日期"
      v-model="toDate"
      :min-date="minDate"
      :max-date="maxDate"
      :date-formatter="formatDate"
      icon="calendar"
      expanded
      @input="onDateInput">
    </b-datepicker>
  </b-field>
  <horizontal-bar-chart :chart-data="chartData"></horizontal-bar-chart>
</div>
</template>

<script>
import config from '@/core/config'
import cache from '@/core/cache'
import HorizontalBarChart from '@/components/charts/HorizontalBarChart'
import DateQuick from '@/components/DateQuick'
import { nextChartColor, fromNow, sortDate } from '@/core/util'

export default {
  name: 'analyprops',
  components: { HorizontalBarChart, DateQuick },
  mounted () {
    this.getRecord()
  },
  computed: {
    regional () {
      return cache.getR(true)
    }
  },
  data () {
    return {
      minDate: new Date(2018, 8, 1),
      maxDate: new Date(),
      fromDate: fromNow({ days: -7 }),
      toDate: new Date(),
      chartData: this.buildChartData(),
      statData: null,
      isLoading: false,
      selectedShop: 1
    }
  },
  methods: {
    getPropName (ptype, pid) {
      let char = null
      if (ptype === 1) {
        char = config.CHARACTERS_WITH_KEY[pid]
      } else if (ptype === 2) {
        char = config.PACK_PROPS_WITH_KEY[pid]
      }
      if (char) return char.name
      return pid
    },
    onDateQuick (date) {
      this.fromDate = date.fromDate
      this.toDate = date.toDate
    },
    onDateInput (date) {
      this.getRecord()
    },
    onShopSelect (select) {
      console.log('onShopSelect %s', select)
      this.buildShopData()
    },
    buildChartData (labels, datasets) {
      labels = labels || []
      datasets = datasets || []
      return { labels, datasets }
    },
    // 创建各个要分析的属性数据的 dataset
    buildPropDataSets (labels, propsInStat, dataSetsObj) {
      const datasets = []
      for (let i = 0; i < propsInStat.length; i++) {
        const pid = propsInStat[i]
        const propName = this.getPropName(this.selectedShop, pid)
        const color = nextChartColor(i)
        const dataset = { label: `${propName}`, data: [], backgroundColor: color }
        for (const date of labels) {
          const day = dataSetsObj[date]
          dataset.data.push(day[pid] || 0)
        }
        datasets.push(dataset)
      }
      return datasets
    },
    // 创建 numuser 字段的 dataset
    buildNumUserDataSets (labels, propsInStat, dataSetsObj) {
      // 加入 numuser 这个字段
      const dataset = { label: 'numuser', data: [], backgroundColor: nextChartColor(propsInStat.length) }
      for (const date of labels) {
        const day = dataSetsObj[date]
        dataset.data.push(day.numuser)
      }
      return [dataset]
    },
    buildShopData () {
      // 获得 propsId 的数组
      let propsInStat = {}

      // 留存图表的数据
      const dataSetsObj = {}
      this.statData.forEach(item => {
        if (!dataSetsObj[item.date]) {
          dataSetsObj[item.date] = { numuser: item.shop.numuser }
        }
        // console.log('dataSetObj[%s] %o', item.date, dataSetsObj[item.date])
        for (const [propKey, propItem] of Object.entries(item.shop.items)) {
          let [propType, propId] = propKey.split('_')
          propType = Number.parseInt(propType)
          propId = Number.parseInt(propId)
          // this.selectedShop 的值是1或者2，与 propType 对应
          if (propType === this.selectedShop) {
            propsInStat[propId] = true
            dataSetsObj[item.date][propId] = Number.parseInt(propItem)
          }
        }
      })
      // 其中的内容是 date 字符串
      const labels = sortDate(Object.keys(dataSetsObj))
      // 把 propsInstat 转换成 Array
      propsInStat = Object.keys(propsInStat).sort()

      let datasets = null
      if (this.selectedShop === 3) {
        datasets = this.buildNumUserDataSets(labels, propsInStat, dataSetsObj)
      } else {
        datasets = this.buildPropDataSets(labels, propsInStat, dataSetsObj)
      }

      this.chartData = this.buildChartData(labels, datasets)
      console.log('buildShopData chartData:%o', this.chartData)
    },
    buildData (data) {
      // 留存表格的数据，需要把表格“横”过来
      const stat = data.stat
      this.statData = stat
    },
    clearRecord () {
      this.chartData = this.buildChartData()
      this.statData = null
    },
    async getRecord () {
      if (this.isLoading) {
        return
      }
      if (!this.hub.checkFilters([this.regional, '区服'])) {
        this.clearRecord()
        return
      }
      this.isLoading = true
      try {
        const data = await this.mjp.get('/analy/shop/', {
          from_date: this.formatDate(this.fromDate),
          to_date: this.formatDate(this.toDate)
        })
        this.buildData(data)
        this.buildShopData()
      } catch (error) {
        console.error(error)
      }
      this.isLoading = false
    }
  }
}
</script>
